import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import utils, { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_LCNE_USR_INFO } from "@/tra/tancis/ptli/usr/lcneusr/services/PtliLcneUsrService";
import { LCNE_USE_TP_CD_UTIL } from "@/tra/tancis/ptli/usr/lcneusr/services/PtliLcneUsrService";

/*
 * License User Details
 * !== 면허 사용자 상세 ==!
 */
export const PTLI0906004Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_lcmi0001", "auth_ptli0025", "auth_eswi0001", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { openPopup } = usePopup();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const { lcneCoAplyId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const [memInfo, setMemInfo] = useState<any|null>(null);

    const [ffaexpmtStts, setFfaexpmtStts] = useState<{
        isFeatureActive: Boolean | null, membStts: 'EXEMPTED' | 'NOT_EXEMPTED' | 'NOT_FOUND' | null
    }>({ isFeatureActive: null, membStts: null });


    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { getResource } = useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "LCM0001" }, { area: "cstmCd" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // License User Information !== 면허 사용자 정보 ==!
        lcneUsrInfo: useForm({
            defaultSchema: SF_LCNE_USR_INFO,
        }),
    };

    const ectYn = form.lcneUsrInfo.watch("ectYn");

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get License User Information !== 면허 사용자 정보 조회 ==!
        getLcneUsrInfo: useFetch({
            api: () => APIS.getLcneUsrInfo(lcneCoAplyId),
            enabled: !!lcneCoAplyId,
            onSuccess: (data) => {
                const lcneUsr = data.lcneUsr.content;
                const lcneTpComnCdList = getResource("comnCd", "LCM0001");
                const lcneTpCdArr = LCNE_USE_TP_CD_UTIL.initLcneUseTpCdSchema({
                    lcneUseTpCdArray: lcneUsr.lcneTpCdArray,
                    form: form.lcneUsrInfo,
                    lcneTpComnCdList: lcneTpComnCdList,
                    t: t,
                });
                form.lcneUsrInfo.setValues(lcneUsr);
                setMemInfo((prev: any) => ({
                    ...prev,
                    orgMem: data.lcneUsr?.orgMem,
                    memStts: data.lcneUsr?.memStts,
                }));
            },
            onError: (error) => {},
            showToast: true,
        }),
        
        // delete License User !== 면허 사용자 삭제 ==!
        deleteLcneUsr: useFetch({
            api: () => APIS.deleteLcneUsr(lcneCoAplyId),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00060", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onCancel: () => {
                        navigate(URLS.ptli0906001q);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),

        // Reset the License User password. !== 라이센스 사용자 비밀번호를 초기화한다. ==!
        updateLcneUsrPwdInit: useFetch({
            api: (data) => APIS.updateLcneUsrPwdInit(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.ptl.00764", // A temporary password has been sent. !==  임시 비밀번호가 발송되었습니다. ==!
                });
            },
            onError: (error) => {
                const data = error.response.data;
                modal.openModal({
                    content: data.errorMessage,
                });
            },
        }),

        // Change the company name to the name stored in TAXPAYER.  !== 업체명을 TAXPAYER 저장 된 업체명으로 변경한다. ==!
        updateLcneUsrCoNm: useFetch({
            api: (data) => APIS.updateLcneUsrCoNm(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onClose: () => navigate(0),
                });
            },
            onError: (error) => {
                const data = error.response.data;
                modal.openModal({
                    content: data.errorMessage,
                });
            },
        }),

        getLcneUsrFfaexpmtStts: useFetch({
            api: () => APIS.getLcneUsrFfaexpmtStts(lcneCoAplyId),
            enabled: !!lcneCoAplyId,
            onSuccess: (data) => {
                const ffaExmptStts = data.ffaExmptStts.content;

                setFfaexpmtStts(ffaExmptStts);
            },
            onError: (error) => {},
            showToast: false,
        }),

        updateLcneUsrFfaexpmt: useFetch({
            api: (data) => APIS.updateLcneUsrFfaexpmt(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                });
            },
            onError: (error) => {
                const data = error.response.data;
                modal.openModal({
                    content: data.errorMessage,
                });
            },
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Delete License User !== 면허 사용자 삭제 ==!
        onDeleteBtnClick: () => {
            if (!!aprvId || rtrnYn === "Y") {
                modal.openModal({ content: "msg.ptl.00713" }); // This is a license application that has already been approved/rejected. !== 이미 승인/반려된 면허 신청건 입니다. ==!
                return;
            }

            modal.openModal({
                content: "msg.com.00049", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    fetch.deleteLcneUsr.fetch();
                },
            });
        },
        onEditBtnClick: () => {
            if (!!aprvId || rtrnYn === "Y") {
                modal.openModal({ content: "msg.ptl.00713" }); // This is a license application that has already been approved/rejected. !== 이미 승인/반려된 면허 신청건 입니다. ==!
                return;
            }
            navigate(`${URLS.ptli0906003s}/${lcneCoAplyId}`);
        },

        onResetBtnClick: () => {
            modal.openModal({
                content: "msg.ptl.00749", // Do you want to reset your password? !== 비밀번호를 초기화 하시겠습니까? ==!
                onConfirm: () => {
                    if (!comnUtils.isEmpty(form.lcneUsrInfo.errors)) {
                        toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                        return;
                    }
                    form.lcneUsrInfo.handleSubmit(
                        () => {
                            const usrAplyInfo = form.lcneUsrInfo.getValues();

                            fetch.updateLcneUsrPwdInit.fetch(usrAplyInfo);
                        },
                        () => {
                            toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                        },
                    )();
                },
            });
        },

        onChgCoNmBtnClick: async () => {
            const resp = await APIS.getPayerTinNoLst(form.lcneUsrInfo.getValue("coTin"), "");

            const tinNoList = resp.data.tinNoList.content;

            if (tinNoList.length == 1) {
                const tinNoInfo = tinNoList[0];
                form.lcneUsrInfo.setValue("taxpayerCoNm", tinNoInfo.coNm);

                modal.openModal({
                    content: t("msg.ptl.00833", { 0: form.lcneUsrInfo.getValue("coNm"), 1: tinNoInfo.coNm }),
                    onConfirm: () => {
                        if (!comnUtils.isEmpty(form.lcneUsrInfo.errors)) {
                            toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                            return;
                        }
                        form.lcneUsrInfo.handleSubmit(
                            () => {
                                const lcneUsrInfo = form.lcneUsrInfo.getValues();
                                fetch.updateLcneUsrCoNm.fetch(lcneUsrInfo);
                            },
                            () => {
                                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                            },
                        )();
                    },
                });
            } else {
                toast.showToast({ type: "error", content: "msg.clr.00004" });
            }
        },
        onExmpTglBtnClick: async () => {
            modal.openModal({
                content: ffaexpmtStts?.membStts === "EXEMPTED"
                                            ? `You are about to cancel the exemption for ${form.lcneUsrInfo.getValue("coNm")} (${form.lcneUsrInfo.getValue("coTin")}). FFA membership verification on declaration will be enabled. Do you wish to proceed?`
                                            : `You are about to exempt ${form.lcneUsrInfo.getValue("coNm")} (${form.lcneUsrInfo.getValue("coTin")}) from FFA Declarations. This will disable FFA membership verification on declaration. Do you wish to proceed?`
,
                    onConfirm:  async () => {
                        if (!comnUtils.isEmpty(form.lcneUsrInfo.errors)) {
                            toast.showToast({ type: "warning", content: "msg.00002" });
                            return;
                        }
                         await APIS.updateLcneUsrFfaexpmt(form.lcneUsrInfo.getValues());
                         fetch.getLcneUsrFfaexpmtStts.fetch();
                        
                    },
                });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getLcneUsrInfo.fetch();
        fetch.getLcneUsrFfaexpmtStts.fetch();
        form.lcneUsrInfo.setEditable(false);
    }, []);

    const aprvId = form.lcneUsrInfo.watch("aprvId");
    const rtrnYn = form.lcneUsrInfo.watch("rtrnYn");

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.coTin}></Group.Control>
                                <Group.Control {...form.lcneUsrInfo.schema.coNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.cstmOfceCd}></Group.Control>
                                <Group.Control {...form.lcneUsrInfo.schema.usrStatCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.rprsTelno}></Group.Control>
                                <Group.Control {...form.lcneUsrInfo.schema.rprsFaxNo}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.rprsEml}></Group.Control>
                                {form.lcneUsrInfo.schema?.orgMemb ? (
                                    <Group.Field
                                        size={4}
                                        type="text"
                                        label="Organization"
                                        control={
                                        form.lcneUsrInfo.schema.memStts
                                            ? `${form.lcneUsrInfo.schema.orgMemb} (${form.lcneUsrInfo.schema.memStts})`
                                            : form.lcneUsrInfo.schema.orgMemb
                                        }
                                    />
                                ): null}
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.coAddr}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.ectYn}></Group.Control>
                            </Group.Row>
                            {ectYn === "N" && (
                                <Group.Row>
                                    <Group.Control {...form.lcneUsrInfo.schema.lcneTpCd}></Group.Control>
                                </Group.Row>
                            )}
                            {ectYn === "N" &&
                                LCNE_USE_TP_CD_UTIL.isLcneUseTpCdTarget({
                                    lcneTpCd: "1",
                                    lcneTpCdChekedArr: form.lcneUsrInfo.getValue("lcneTpCd"),
                                }) && (
                                    <Group.Row>
                                        <Group.Control
                                            {...form.lcneUsrInfo.schema[LCNE_USE_TP_CD_UTIL.getLcneUseTpCdVarNm("1")]}
                                        ></Group.Control>
                                    </Group.Row>
                                )}
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.mdfyRsn}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0906001q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        color="warning"
                        onClick={() => {
                            handler.onResetBtnClick();
                        }}
                    >
                        {t("B_RESET_PWD")}
                    </Button>
                    <Button
                        color="warning"
                        onClick={() => {
                            handler.onChgCoNmBtnClick();
                        }}
                    >
                        {t("B_CO_NM_MDFY")}
                    </Button>
                    {/* update FFA exemption - show only if feature active */}
                    {(
                        Array.isArray(form.lcneUsrInfo.getValue("lcneTpCd"))
                            ? form.lcneUsrInfo.getValue("lcneTpCd")?.includes("1")
                            : form.lcneUsrInfo.getValue("lcneTpCd") === "1"
                        ) && ffaexpmtStts?.isFeatureActive && ffaexpmtStts?.membStts !== "NOT_FOUND" && (
                        <Button color="warning" onClick={() => {
                            handler.onExmpTglBtnClick()
                        }}>
                            {ffaexpmtStts?.membStts === "EXEMPTED"
                            ? t("REVOKE FFA EXEMPTION")
                            : t("GRANT FFA EXEMPTION")}
                        </Button>
                        )}

                    <Layout.Button
                        role={"delete"}
                        onClick={() => {
                            handler.onDeleteBtnClick();
                        }}
                    />
                    <Layout.Button
                        role={"edit"}
                        onClick={() => {
                            handler.onEditBtnClick();
                        }}
                    />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
